import * as _ from 'lodash'
import {SnapshotBO} from "./SnapshotBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {ErrorMessage_restate} from "../PA.Core/Basic/MessageUtils";
import {WB_SnapshotRow, WB_WorkflowStatusRow} from "../PA.Core/PAdbSchemaRows";
import {PASearch} from "../PA.Core/PASearch";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Snapshot, esWB_Workflow_Status} from "../PA.Core/PAdbSchema";


export class SnapshotBOValidations {

    static Validate(aBO: SnapshotBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            SnapshotBOValidations.ValidateExistingSnapshot(aBO)
                .then((ignore) => {
                    // Skip further validations if Errors exist
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                        resolve()
                        return
                    }
                })
                .then((ignore) => {
                    if(aBO.drWB_Snapshot.WB_SnapshotTypeRow.cif.SNAPSHOT_TYPE_ID == 'LE_Spend_Accrual')
                        return SnapshotBOValidations.ValidateLESpendSnapshot(aBO)
                    else
                        resolve()
                })
                .then((ignore) => {
                    if(aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                        resolve()
                        return
                    }
                    else
                        resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static ValidateExistingSnapshot(aBO: SnapshotBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let selectedStatusWBId: number = aBO.WB_Snapshot.cif.WORKFLOW_STATUS_ID_NEXT
            let serverProcessID: string = aBO.WB_Snapshot.WB_SnapshotTypeRow.cif.SERVER_PROCESS_ID
            let selectedStatusId: string = ""
            let dbContext = new PAdbContext({})

            dbContext.findAll(esWB_Workflow_Status, {where: {WB_STATUS_ID:  selectedStatusWBId}})
                .then((workflowStatus: WB_WorkflowStatusRow[]) => {
                    if(_.isEmpty(workflowStatus)){
                        resolve()
                        return
                    }
                    selectedStatusId = workflowStatus[0].cif.STATUS_ID

                    if(selectedStatusId=="Snapshot_Posted" && serverProcessID==="ACCRUAL"){
                        dbContext.findAll(esWB_Snapshot, {where: { WB_PERIOD_ID_PARENT: aBO.WB_Snapshot.cif.WB_PERIOD_ID_PARENT,
                                WB_PERIOD_ID: aBO.WB_Snapshot.cif.WB_PERIOD_ID,
                                WORKFLOW_STATUS_ID: aBO.WB_Snapshot.cif.WORKFLOW_STATUS_ID_NEXT,
                                WB_SNAPSHOT_ID: {neq: aBO.WB_Snapshot.cif.WB_SNAPSHOT_ID},}})
                                .then((arrRows: any[]) => {

                                        if (!_.isEmpty(arrRows)) {
                                            let arrSnapshotName: string = _.map(_.sortedUniqBy(arrRows, 'SNAPSHOT_ID'), 'SNAPSHOT_ID').join(', ')
                                            ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'SamePeriodParentPeriodComboExists', "Cannot advance current snapshot into this status. Another snapshot "+arrSnapshotName+" for the same period and parent period already exists.")
                                            return
                                        }
                                    })
                                    .then((ignore) => {
                                        resolve()
                                    })
                                    .catch((err) => {
                                        error(err)
                                    })
                    }
                    else if (selectedStatusId == 'Snapshot_for_Validation' || selectedStatusId == 'Snapshot_GL_Posting' || selectedStatusId == 'Sent_To_GL' || selectedStatusId == 'GL_Posting_Confirmed' ) {
                        PASearch.find(
                            'vUI_Snapshot_Search',
                            {
                                WB_PERIOD_ID_PARENT: aBO.WB_Snapshot.cif.WB_PERIOD_ID_PARENT,
                                WB_PERIOD_ID: aBO.WB_Snapshot.cif.WB_PERIOD_ID,
                                WORKFLOW_STATUS_ID: aBO.WB_Snapshot.cif.WORKFLOW_STATUS_ID_NEXT,
                                WB_SNAPSHOT_ID: {neq: aBO.WB_Snapshot.cif.WB_SNAPSHOT_ID}
                            },
                            {
                                WB_PERIOD_ID_PARENT: {type: "number"},
                                WB_PERIOD_ID: {type: "number"},
                                WORKFLOW_STATUS_ID: {type: "number"},
                                WB_SNAPSHOT_ID: {type: "number"}
                            },
                            [],
                            0,
                            [])
                            .then((arrRows: any[]) => {
                                debugger
                                if (!_.isEmpty(arrRows)) {
                                    let arrSnapshotName: string = _.map(_.sortedUniqBy(arrRows, 'SNAPSHOT_ID'), 'SNAPSHOT_ID').join(', ')
                                    ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'SamePeriodParentPeriodComboExists', "Cannot advance current snapshot into this status. Another snapshot "+arrSnapshotName+" for the same period and parent period already exists.")
                                    return
                                }
                            })
                            .then((ignore) => {
                                resolve()
                            })
                            .catch((err) => {
                                error(err)
                            })
                    }
                    else {
                        resolve()
                    }
                })
        })
    }

    /**
     * For LE Spend snapshots, validate only one per year
     *         WB_SNAPSHOT_ID   WB_SNAPSHOT_ID_PARENT
     * parent  X                0
     * child   Y                X
     *
     * Case 1 save snapshot without any children => ID <> parent.ID
     * Case 2 save child snapshot (from queue process, for recurring snapshots) => ID <> child.ID_PARENT
     * Case 3 save snapshot with child => ID <> parent.ID AND ID_PARENT <> parent.ID
     */
    static ValidateLESpendSnapshot(aBO: SnapshotBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            const snapshot: WB_SnapshotRow = aBO.WB_Snapshot
            let dbContext = new PAdbContext({})
            dbContext.findAll(esWB_Snapshot, {
                where: {
                    WB_PERIOD_ID_PARENT:  snapshot.cif.WB_PERIOD_ID_PARENT,
                    WB_SNAPSHOTM_ID: snapshot.cif.WB_SNAPSHOTM_ID,
                    DELETED_IND: {neq: '1'},
                    WB_SNAPSHOT_ID: {
                        nin: [
                            snapshot.cif.WB_SNAPSHOT_ID, // Case 1
                            snapshot.cif.WB_SNAPSHOT_ID_PARENT, // Case 2
                        ],
                    },
                    WB_SNAPSHOT_ID_PARENT: {
                        neq: snapshot.cif.WB_SNAPSHOT_ID, // Case 3
                    },
                }
            })
                .then((arrRows: any[]) => {
                    debugger
                    if (!_.isEmpty(arrRows)) {
                        let arrSnapshotName: string = _.map(_.sortedUniqBy(arrRows, 'SNAPSHOT_ID'), 'SNAPSHOT_ID').join(', ')
                        ErrorMessage_restate(aBO.ValidateMessageProvider, true, 'SamePeriodLESpendComboExists', "Cannot save the snapshot. Another snapshot "+arrSnapshotName+" for the same period already exists.")
                        return
                    }
                })
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static ValidateBeforeDelete(aBO: SnapshotBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            let oPrimaryWrkflwProcessor = aBO.PrimaryWorkflowProcessor
            if(_.isUndefined(oPrimaryWrkflwProcessor) || _.isNull(oPrimaryWrkflwProcessor)) {
                resolve()
                return
            }

            let currentState: WB_WorkflowStatusRow = oPrimaryWrkflwProcessor.CurrentState

            if(_.isUndefined(currentState) || _.isNull(currentState)) {
                resolve()
                return
            }

            let currentStateId: string = currentState.cif.STATUS_ID
            let bCanDelete: boolean = false

            if(currentStateId != 'Snapshot_GL_Posting' && currentStateId != 'Sent_To_GL' && currentStateId != 'GL_Posting_Confirmed')
                bCanDelete = true

            ErrorMessage_restate(aBO.DeleteMessageProvider, !bCanDelete,
                "SnapshotCannotBeDeleted", "Snapshot cannot be deleted.")

            resolve()
        })
    }
}
